function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.455 21.899l-.098-.1.767-.627.002.001.537-.457h.002l.066-.057.545.496c.062.058.13.107.201.145l.705.406-1.315-.245-1.412.438zm6.355.483l-4.221-3.846c-.008-.008-.017-.013-.025-.02a.722.722 0 00-.067-.05l-.02-.013a.704.704 0 01-.01-.008l-.01-.008a.95.95 0 00-.95-.087l-4.5 2.366h-2.172l-2.46-.334a5.866 5.866 0 00-3.311-.311l-1.065 1.36v.742c0 .886.733 1.605 1.64 1.605h19.235c.459-.008.866-.375.954-.834l-3.018-.562zm-22.283-3.3a1.436 1.436 0 00.294 2.043c.5.369 1.113.352 1.666.086.34-.16.607-.208.959-.044l.462-.598a.647.647 0 00-.134-.923l-1.156-.852-.052-.039a1.517 1.517 0 00-2.039.326zm-.596 4.696h3.442v-.597c0-.568-.472-1.029-1.051-1.029h-2.17l-.23.456h-.085v-1.182c-.013-.314-.114-.486-.31-.678l-1.355-1.324v2.636c0 .949.785 1.718 1.76 1.718zM30 26.25H0v-1.243h30v1.243z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 3a5 5 0 11-4.383 2.594M19.14 4.822a5 5 0 013.07-1.76",
  stroke: "currentColor",
  strokeWidth: "2"
})));